import React, { FC } from 'react';
import styles from './MidtermGoftino.module.scss';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import useDevice from '@/hooks/useDevice';
interface MidTermGoftinoProps {
  onClose: () => void;
}
const MidTermGoftino: FC<MidTermGoftinoProps> = ({
  onClose
}) => {
  const {
    isMobile
  } = useDevice();
  return <Box className={isMobile ? styles['iframe-mobile'] : styles['iframe-desktop']} data-sentry-element="Box" data-sentry-component="MidTermGoftino" data-sentry-source-file="MidtermGoftino.tsx">
      <Box className={styles['close-button']} data-sentry-element="Box" data-sentry-source-file="MidtermGoftino.tsx">
        <Icon name="close" type="inherit" size={18} onClick={onClose} data-sentry-element="Icon" data-sentry-source-file="MidtermGoftino.tsx" />
      </Box>
      <iframe src="https://www.goftino.com/c/738x4G" className={styles['iframe']} title="Iframe" />
    </Box>;
};
export default MidTermGoftino;